import { render } from "./customerNaveBar.vue?vue&type=template&id=5921bcf4&scoped=true"
import script from "./customerNaveBar.vue?vue&type=script&lang=js"
export * from "./customerNaveBar.vue?vue&type=script&lang=js"

import "./customerNaveBar.vue?vue&type=style&index=0&id=5921bcf4&scoped=true&lang=scss"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5921bcf4"]])

export default __exports__